
// Icons
import changePasswordIcon from '../../../../../assests/images/layout/header/dropdown-menu/change-password.png'
import logoutIcon from '../../../../../assests/images/layout/header/dropdown-menu/logout.png'
import React from 'react';

export const moreOptionsData = [
  {
    id: "2",
    icon: <img src={changePasswordIcon} alt='change-password' />,
    title: "Change Password",
    path: '',
  },
  {
    id: "4",
    icon: <img src={logoutIcon} alt='logout' />,
    title: "Logout",
    path: '',
  },
];

